import { type RootState } from '@reducers';
import { Collapse } from 'antd';
import { type ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  getDataSourceForProductsTable,
  getProductsTableColumns,
  type ProductTableColumn,
} from '../../fragments/products-table-columns';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { productsLoadByBrand } from '../../reducers/products/reducer';
import Table from '../table';

function BrandProductsComponent(): React.ReactElement {
  const dispatch = useAppDispatch();
  const productsState = useSelector((s: RootState) => s.Products);
  const languageState = useSelector((s: RootState) => s.Language);
  const configState = useSelector((s: RootState) => s.Config);
  const currencyState = useSelector((s: RootState) => s.Currency);
  const featureFlagsState = useSelector((s: RootState) => s.FeatureFlags);
  const warehouseState = useSelector((s: RootState) => s.Warehouse);
  const brandUUID = useSelector((s: RootState) => s.Brand.brand?.uuid);

  const [dataSource, setDataSource] = useState<ProductTableColumn[]>([]);
  const [columns, setColumns] = useState<ColumnsType<object>>([]);

  useEffect((): void => {
    const dataSourceUE: ProductTableColumn[] = getDataSourceForProductsTable({
      Products: productsState,
      Language: languageState,
    });

    const columnsUE: ColumnsType<object> = getProductsTableColumns({
      dataSource: dataSourceUE,
      Config: configState,
      Language: languageState,
      Currency: currencyState,
      FeatureFlags: featureFlagsState,
      Warehouse: warehouseState,
    });

    setDataSource(dataSourceUE);
    setColumns(columnsUE);
  }, [configState, languageState, productsState, productsState.inProcess]);

  return (
    <Collapse
      onChange={(keys: string[]): void => {
        if (keys.includes('products') && brandUUID) {
          dispatch(productsLoadByBrand(brandUUID));
        }
      }}
      items={[
        {
          key: 'products',
          label: 'Products',
          children: (
            <Table
              columns={columns}
              dataSource={dataSource}
              isLoading={!productsState.products}
            />
          ),
        },
      ]}
    />
  );
}

export default BrandProductsComponent;
